import React from 'react';

class Logout extends React.Component {
  componentDidMount() {
    const logoutUrl = process.env.REACT_APP_LOGOUT_URL;

    if (window && window.location && logoutUrl) {
      window.location = logoutUrl;
    }
  }

  render() {
    return null;
  }
}

export default Logout;
